exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.wizard-icon-circle {\n    outline: 0 !important;\n}\n", ""]);

